import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  Button,
} from '@mui/material';
import { hireflixCta, hireflixCtaHover } from '@styles/colors';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import { ErrorIcon } from '../../../../vectors/index';

type HireflixPositionNotFoundModalProps = {
  position?: string;
  isOpen: boolean;
  handleClose: () => void;
};

const HireflixPositionNotFoundModal: FC<HireflixPositionNotFoundModalProps> = ({
  position,
  isOpen,
  handleClose,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      disableEnforceFocus
    >
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>

        <br />
        <ErrorIcon />
        <br />

        <Typography variant="h4" sx={{ p: 3 }}>
          We couldn’t find this position
          {position && (
            <Typography variant="subtitle1" color="text.secondary">
              &quot;{position}&quot;
            </Typography>
          )}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ mb: 6, textAlign: 'center' }}>
          It looks like this position hasn’t been created in Hireflix yet.
          Please create it first before continuing.
        </Typography>

        <Stack spacing={2} width="100%" alignItems="end">
          <Button
            variant="contained"
            color="primary"
            fullWidth
            component={Link}
            to="/employer/hireflix-interviews"
            sx={{
              backgroundColor: hireflixCta,
              '&:hover': {
                backgroundColor: hireflixCtaHover,
              },
            }}
          >
            Go to Hireflix to Create Position
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default HireflixPositionNotFoundModal;
